export const COUNTRYCODE = [
    { Name: "Sweden", Value: "SE" },
    { Name: "Germany", Value: "DE" },
];